import {
  Checkbox,
  Form,
  Input,
  Typography,
} from "antd";

import React, { useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import {
  MailOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { translation } from "../../../../i18n/translationConstant";
import { LoginSignupFormType } from "../../../../Utils/Constants/loginSignupFormTypes";
import { vuaIdSuffix } from "../../../../Utils/Constants/vuaIdSuffix";

import PinInputComponent from "../../../Common/Components/PinInput";

import "./index.css";

interface IUserProp extends WithTranslation {
  vuaIdValidator: (_: any, value: string) => void;
  isVuaIdDisabled?: boolean;
  vuaId?: string;
  email?: string;
  form?: any;
}

const UserInformation: React.FC<IUserProp> = ({
  t,
  vuaIdValidator,
  vuaId,
  email,
  form,
  isVuaIdDisabled,
}) => {
  const onNameChange = (e: any) => {
    e.target.value = e.target.value.replace(
      /[^A-Za-z]+/g,
      ""
    );
  };

  const onVUANameChange = (e: any) => {
    e.target.value = e.target.value.replace(
      /[^A-Za-z0-9]+/g,
      ""
    );
  };

  useEffect(() => {
    if (!form) {
      return;
    }

    const values: any = {};

    if (vuaId) {
      values.vuaId = vuaId;
    }

    if (email) {
      values[LoginSignupFormType.email] = email;
    }

    if (Object.keys(values).length > 0) {
      form.setFieldsValue(values);
    }
  }, [form, vuaId, email]);

  const disableInputVuaId =
    !!vuaId && !!isVuaIdDisabled;

  return (
    <div className="userInformationForm width">
      {/* FIRST NAME */}
      <Form.Item
        label={t(translation.lblFirstName)}
        required={false}
        rules={[
          {
            required: true,
            message: t(
              translation.errorRequiredFirstName
            ),
          },
        ]}
        name={LoginSignupFormType.firstName}
        className="signupFormItem"
      >
        <Input
          id="firstName"
          type="text"
          onInput={onNameChange}
          placeholder={t(translation.lblFirstName)}
          allowClear={true}
          prefix={
            <UserOutlined className="signupFieldIcon" />
          }
          className="signupInput"
        />
      </Form.Item>

      {/* LAST NAME */}
      <Form.Item
        label={t(translation.lblLastName)}
        required={false}
        rules={[
          {
            required: true,
            message: t(
              translation.errorRequiredLastName
            ),
          },
        ]}
        name={LoginSignupFormType.lastName}
        className="signupFormItem"
      >
        <Input
          id="lastName"
          type="text"
          onInput={onNameChange}
          placeholder={t(translation.lblLastName)}
          allowClear={true}
          prefix={
            <UserOutlined className="signupFieldIcon" />
          }
          className="signupInput"
        />
      </Form.Item>

      {/* EMAIL - OPTIONAL */}
      <Form.Item
        label={t("lblEmail")}
        required={false}
        name={LoginSignupFormType.email}
        className="signupFormItem"
        rules={[
          {
            type: "email",
            message: t(
              translation.errorEnterValidEmail
            ),
          },
        ]}
      >
        <Input
          id="email"
          type="email"
          placeholder={t("lblEmail")}
          allowClear={true}
          prefix={
            <MailOutlined className="signupFieldIcon" />
          }
          className="signupInput"
        />
      </Form.Item>

      {/* INK HANDLE */}
      <Form.Item
        label={t(translation.lblEnterAAHandle)}
        required={false}
        hasFeedback={true}
        rules={[
          {
            required: true,
            message: t(
              translation.errorEnterAAHandle
            ),
          },
          {
            validator: vuaIdValidator,
          },
        ]}
        name={LoginSignupFormType.vuaId}
        className="signupFormItem"
      >
        <Input
          id="vuaId"
          type="text"
          onInput={onVUANameChange}
          placeholder={t(
            translation.lblEnterAAHandle
          )}
          prefix={
            <span className="inkHandlePrefix">@</span>
          }
          suffix={vuaIdSuffix.value}
          allowClear={true}
          disabled={disableInputVuaId}
          className="signupInput"
        />
      </Form.Item>

      {/* PIN */}
      <div className="signupPinWrapper">
        <div className="pinFieldLabel">{t(translation.lblSetPin)}</div>
        <PinInputComponent
          id="pin"
          label={t(translation.lblSetPin)}
          className="inputCss1"
        />
      </div>

      {/* TERMS & CONDITIONS */}
      <Form.Item
        valuePropName="checked"
        rules={[
          {
            validator: (_, checked) => {
              if (!checked) {
                return Promise.reject(
                  new Error(
                    "Please agree to Terms and Conditions"
                  )
                );
              }

              return Promise.resolve();
            },
          },
        ]}
        name="terms"
        className="signupTermsItem"
      >
        <Checkbox className="checkBox">
          <Typography.Text className="agreed">
            {t(translation.lblIAgreeTo)}{" "}
            <Typography.Text className="termsAndCondition">
              <a
                href="https://www.ink-aa.com/terms-conditions.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(translation.lblTermsAndConditions)}
              </a>
            </Typography.Text>
          </Typography.Text>
        </Checkbox>
      </Form.Item>
    </div>
  );
};

export default withTranslation()(UserInformation);
